import { render, staticRenderFns } from "./course_catalog.vue?vue&type=template&id=6ec85d74&scoped=true"
import script from "./course_catalog.vue?vue&type=script&lang=js"
export * from "./course_catalog.vue?vue&type=script&lang=js"
import style0 from "./course_catalog.vue?vue&type=style&index=0&id=6ec85d74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec85d74",
  null
  
)

export default component.exports